import Fade from '@mui/material/Fade';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { colors, fontSize, fontWeight, TypographyStyledGlobal, TypographyDivStyledGlobal } from '../../../theme';
import { ClauseFilterLabelProps, ScopeLabelProps } from '../../Dashboard/dashboardInterfaces';
import { MediumBoxModalStyled, OneLineTitleStyled } from '../styled';
import ChatbotConversation from './DashboardModalContent/ChatbotModal/ChatbotConversation';
import { ChatbotModalProps } from './dashboardModalInterface';
import { CloseIconModalStyled, ModalStyled, AllVerbatimCardHeader, ChatbotImageStyled } from './styled';

const ChatbotModal: FC<ChatbotModalProps> = ({ openModal, questionLabel, setOpenModal, selectedClauseFilterLabel, getChatbotResponse, conversation, waitingForChatAnswer, handleIsRenderedChat, summary, surveyId, selectedScopeLabel, surveyName, dashboardName }) => {
    const handleClose = () => {
        setOpenModal(false);
    };
    const { t } = useTranslation('dashboard');
    const displayedFilterClauseLabel: string | undefined = selectedClauseFilterLabel ? selectedClauseFilterLabel.map((filter: ClauseFilterLabelProps) => `${filter.filterLabel} : ${filter.modalitiesLabel}`).join(' || ') : undefined;
    const displayedScopeClauseLabel: string | undefined = selectedScopeLabel ? selectedScopeLabel.map((scope: ScopeLabelProps) => `${scope.scopeLabel} : ${scope.modalitiesLabel}`).join(' || ') : undefined;

    return (
        <ModalStyled
            aria-describedby="modal-modal-description"
            aria-labelledby="modal-modal-title"
            onClose={handleClose}
            open={openModal}
        >
            <Fade in={openModal}>
                <MediumBoxModalStyled>
                    <CloseIconModalStyled onClick={handleClose} />
                    <AllVerbatimCardHeader>
                        <TypographyDivStyledGlobal color={colors.black000} paddingTop='10px' size={fontSize.ml} weight={fontWeight.semiBold}>
                            {questionLabel}
                            <OneLineTitleStyled>
                                <TypographyStyledGlobal color={colors.grey400} fontStyle='italic' size={fontSize.sm} textDecoration='underline' weight={fontWeight.semiRegular} whiteSpace='nowrap'>
                                    {`${t('filter.superTitle')} :`}
                                </TypographyStyledGlobal>
                                <TypographyStyledGlobal color={colors.grey400} fontStyle='italic' margin='0px 0px 0px 5px' size={fontSize.sm} weight={fontWeight.semiRegular}>
                                    {displayedFilterClauseLabel || t('filter.noFilter')}
                                </TypographyStyledGlobal>
                            </OneLineTitleStyled>
                        </TypographyDivStyledGlobal>
                        <ChatbotImageStyled />
                    </AllVerbatimCardHeader>
                    <ChatbotConversation conversation={conversation} dashboardName={dashboardName} filterClauseLabel={displayedFilterClauseLabel} getChatbotResponse={getChatbotResponse} handleIsRenderedChat={handleIsRenderedChat} questionLabel={questionLabel} scopeClauseLabel={displayedScopeClauseLabel} summary={summary} surveyId={surveyId} surveyName={surveyName} waitingForChatAnswer={waitingForChatAnswer} />
                </MediumBoxModalStyled>
            </Fade>
        </ModalStyled>
    );
};

export default ChatbotModal;
